import React, { useEffect, useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from "../apiConfig";

const NoticeManage = () => {
  const history = useHistory();
  const token = localStorage.getItem("jwtToken");
  const decoded = jwt_decode(token);
  const user_id = decoded.user_id;

  const [notice, setNotice] = useState({ description: "" });
  const [loading, setLoading] = useState(false);

  // Fetch existing notice on load
  useEffect(() => {
    axios
      .get(`${apiConfig.baseURL}/api/users/NoticeManage`)
      .then((res) => {
        if (res.status === 200 && res.data) {
          setNotice({ description: res.data.description || "" });
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const handleChange = (e) => {
    setNotice({ ...notice, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!notice.description) return alert("Description required");

    setLoading(true);

    axios
      .post(`${apiConfig.baseURL}/api/users/NoticeManage`, {
        description: notice.description,
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          alert("Updated Successfully");
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <div id="main-wrapper" className="show">
        <Navbar />
        <Chatbox />
        <HeaderRight />
        <LeftSidebar />

        <div className="content-body">
          <div className="container-fluid">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Notice Manage</h4>
                </div>

                <div className="card-body">
                  <div className="basic-form">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Notice Description
                        </label>
                        <div className="col-sm-9">
                          <textarea
                            placeholder="Notice Description"
                            className="form-control"
                            name="description"
                            value={notice.description}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <div className="col-sm-2">
                          <button
                            className="btn btn-primary form-control"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>

                      {loading && (
                        <div style={{ color: "blue", fontWeight: "bold" }}>
                          Please wait, updating...
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default NoticeManage;
